export default __webpack_public_path__ + "static/media/FuturoEmpreendedor.e765def7.png";